import { DaymapQuery as a } from "../daymapQuery.js";
var t;
((n) => {
  class c extends a {
    constructor(e) {
      super(
        ["annoucements", e.appVersion, e.deviceType],
        e,
        `/lms/api/coms/notifications/announcements?appVersion=${e.appVersion}&deviceType=${e.deviceType}`,
        null,
        { enabled: !1 }
      );
    }
  }
  n.GetAnnoucements = c;
  class s extends a {
    constructor(e) {
      super(
        ["annoucements", e.id],
        e,
        `/lms/api/coms/notifications/announcementread?announcementID=${e.id}`,
        null,
        { enabled: !1 }
      );
    }
  }
  n.SetRead = s;
})(t || (t = {}));
export {
  t as announcements
};
//# sourceMappingURL=index.js.map
